

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "Ahmed Raza",
  title: "Hi all, I'm Ahmed",
  subTitle: emoji(
    "Software Engineer | Junior Web Developer at WADDCO | Former Core Team Member of Google DSC"
  ),
  resumeLink:
    "https://drive.google.com/file/d/1Ssos5mwPK2Jv_x4_qmpNZvEDHMdeBeDZ/view?usp=sharing",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/ahmadrazach",
  linkedin: "https://www.linkedin.com/in/ahmadraza/",
  //gmail: "ahmadrazach26@gmail.com",
  // gitlab: "https://gitlab.com/",
  //facebook: "https://www.facebook.com/ahmadraza226/",
  //medium: "https://medium.com/@davidrakosi",
  //stackoverflow: "https://stackoverflow.com/users/13263979/drakosi",
  //instagram: 'https://www.instagram.com/davidrakosi/',
  //twitter: 'https://twitter.com/davidrakosi_',
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "Want to create solutions with the website development",
  skills: [
    
    emoji(
      "⚡ Building progressive business and personal Web Applications ( PWA )"
    ),
    emoji(
      "⚡ Integration of third party services such as Firebase/ SQL / NoSQL"
    ),
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "FAST NUCES",
      logo: require("./assets/images/unilogo.png").default,
      subHeader: "Bachelor of Science in Computer Science",
      duration: "September 2017 - September 2021",
      desc:"Main Events:",
      descBullets: [
        "Core Team Member of Developer Student Club in 2020-2021.",
        "Built a Hostel Automation System to automate the finance, meal, transport & inventory processes.",
        "Managed university events like Daira'18, Welcome'18, and Daira'19 with Event Management Team.",
        "Built Player Performance Analyst project using C# & Windows Form to analyze players' performance using qualitative and quantitative data."
      ],
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Programming ( C++, Javascript, Python )", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Frontend Development( Bootstrap, ReactJS, Adobe XD, Figma )",
      progressPercentage: "90%"
    },
    {
      Stack: "Backend Development( NodeJS, Express, MERN, .NET )",
      progressPercentage: "70%"
    }
  ],
  displayCodersrank: true // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Web Development Intern",
      company: "WADDCO",
      companylogo: require("./assets/images/WADDCOs.png").default,
      date: "AUG 2019 – OCT 2020",
        descBullets:[
          "Created user interfaces on AdobeXD & Figma.",
         "Built responsive cross-browser and mobile-friendly web pages using HTML, CSS, Javascript.",
         "Worked with the Senior team to build SEO-friendly websites."
        ]
    },
    
    
    {
      role: "Junior Web Developer",
      company: "WADDCO",
      companylogo: require("./assets/images/WADDCOs.png").default,
      date: "JAN 2021 – Present",
      descBullets:[
        "Built 6 business portfolio websites.",
       "Developed cross-platform News sharing website & Application using React, Ionic, Firebase, and Electron. Main features include Firebase Authentication, Login/ Signup, and ranking the trending news.",
       "Created two e-commerce websites with features that include easy-to-use checkout, report generation, order and marketing emails, SEO-optimized code, and layout.",
      "Collaborated with the QA testers and Product Managers for testing and performance checks."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: process.env.REACT_APP_GITHUB_TOKEN,
  githubUserName: "ahmadrazach", // Change to your github username to view your profile in Contact Section.
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/2.png").default,
      projectName: "Talk Ideas",
      projectDesc: "Share, find & talk about new ideas",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://hackernews-86174.web.app"
        }
      ]
    } ,
    {
      image: require("./assets/images/HPAS.png").default,
      projectName: "H-PAS",
      projectDesc: "Hostel Process Automation System",
      footerLink: [
        {
          name: "View Frontend Demo",
          url: "https://hostel-process-automation-frontend.netlify.app/w_home.html"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/1.png").default,
      projectName: "SOCIAL BRAND MASTER",
      projectDesc: "Digital Agency Website",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.socialbrandmaster.com/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "UI / UX Design Course",
      subtitle:
        "Completed a course in 'UI / UX and Design' under the HUNARWeekends",
      image: require("./assets/images/designcourse.png").default,
      footerLink: [
        {
          name: "Certification",
          url:
            "https://drive.google.com/file/d/1ko9AYlDb-nSKDl5il-cQXaXRVd2HxdNP/view?usp=sharing"
        }
      ]
    },
    {
      title: "Python Specialization",
      subtitle:
        "Completed specialization in Python from the Coursera ( online platform )",
      image: require("./assets/images/python.png").default,
      footerLink: [
        {
          name: "Certification 1",
          url:
            "https://www.coursera.org/account/accomplishments/certificate/L6S95J6ZM9XQ"
        },
        {
          name: "Certification 2",
          url:
            "https://www.coursera.org/account/accomplishments/certificate/3RQVDY3YER7N"
        },
        {
          name: "Certification 3",
          url:
            "https://www.coursera.org/account/accomplishments/certificate/9UN7E9G5WPHT"
        }
      ]
    },

    {
      title: "Web Development Internship",
      subtitle: "Successfully completed the internship of 3 months in Web Development from WADDCO ",
      image: require("./assets/images/internship.png").default,
      footerLink: [
        {
          name: "Intership Letter",
          url: "https://drive.google.com/file/d/1wVd_aKK45jiENP5hb91VpO35SQgrbgs9/view?usp=sharing"
        }
      ]
    },
    {
      title: "Google Hashcode 2020",
      subtitle:
        "Participated in Google Hashcode 2020 and came 7th in the Pakistan locally",
      image: require("./assets/images/hashcode.png").default,
      footerLink: [
        {
          name: "Certification",
          url:
            "https://drive.google.com/file/d/1w1FQobny7kwvx3x80EZmrfZpHbFH9cPn/view?usp=sharing"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url:
        "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    ""
  ),

  talks: [
    {
      title: "",
      subtitle: "",
      slides_url: "",
      event_url: ""
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    ""
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "You can connect me with the following ways",
  number: "(342) 212 4106",
  email_address: "ahmadrazach26@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "davidrakosi_", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
